import { render, staticRenderFns } from "./CreateAccount-3.vue?vue&type=template&id=1bdd25c1&scoped=true"
import script from "./CreateAccount-3.vue?vue&type=script&lang=js"
export * from "./CreateAccount-3.vue?vue&type=script&lang=js"
import style0 from "./CreateAccount-3.vue?vue&type=style&index=0&id=1bdd25c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd25c1",
  null
  
)

export default component.exports